import {FeatureFlags} from './types';

export const developmentFeatureFlags: FeatureFlags = {
  isEnabledAccountSwitching: true,
  isEnabledPaymentLink: true,
  isEnabledWaitList: false,
  isEnabledBackToSchool: false,
  isSignInDisabled: true,
  isEnabledValidatePoBoxAddress: true,
  isEnabledRequestPhysicalCard: false,
};
